<template>
  <div id="address-item" :class="{ active: addressInfo.check }">
    <label :for="addressInfo.id">
      <div class="name flex-layout">
        <div>
          <span>{{ addressInfo.name }}</span
          ><span class="phone">{{ addressInfo.concatPhone }}</span>
        </div>
        <input
          :id="addressInfo.id"
          class="checkbox address-check"
          type="checkbox"
          @change="change"
          v-model="addressInfo.check"
        />
      </div>
      <div class="address flex-layout">
        <span style="line-height:20px;">{{addressInfo.provinceName + addressInfo.cityName + addressInfo.districtName + addressInfo.clothingCityName + addressInfo.address}}</span>
      </div>
      <div class="btn flex-layout">
        <label @click="setDefault" class="label-flex flex-layout">
          <span>设为默认</span>
          <input
            class="checkbox"
            type="checkbox"
            v-model="addressInfo.default"
          />
        </label>
        <div class="edit-btn flex-layout">
          <van-icon
            @click.stop.prevent="editAddress"
            name="edit"
            size="0.5rem"
          ></van-icon>
          <van-icon
            @click.stop.prevent="delAddress"
            style="margin-left:0.5rem;"
            name="delete"
            size="0.5rem"
          ></van-icon>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "AddressItem",
  data() {
    return {};
  },
  props: {
    addressInfo: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  methods: {
    change() {
      this.$emit("change", this.addressInfo);
    },
    setDefault() {
      this.$emit("setDefault", this.addressInfo.id);
    },
    delAddress() {
      this.$emit("delete", this.addressInfo);
    },
    editAddress() {
      this.$emit("edit", this.addressInfo);
    },
    stcChange() {
      this.$emit("stcChange", this.addressInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
#address-item {
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  padding: 10px 15px;
  font-size: 14px;
  &.active {
    background-color: #e6e6e6;
  }
  > div {
    line-height: 30px;
  }
  .name {
    .phone {
      padding-left: 0.25rem;
      color: #999;
    }
  }
  .address {
    .distance {
      min-width: 2rem;
      justify-content: flex-start;
      font-size: 12px;
      position: relative;
      left: 0.2rem;
    }
  }
  .order-detail {
    display: flex;
    .pack {
      margin-left: 0.5rem;
    }
  }
}

// base
.flex-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label-flex {
  justify-content: flex-start;
}

.checkbox {
  vertical-align: middle;
  display: inline-block;
  width: 20px;
  height: 20px;
  outline: 0;
  background-color: transparent;
  background-image: none;
  -webkit-appearance: none;
  font-family: vant-icon;
  border: 1px solid #aaa;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  &:before {
    content: "";
    display: inline-block;
  }
  &:checked {
    color: #fff;
    background-color: #06bf04;
    border-color: #06bf04;
    &:before {
      content: "\F0C1";
      display: inline-block;
    }
  }
}

.input-text {
  background-color: #eee;
  border-radius: 3px;
  width: 2rem;
  height: 24px;
  padding: 0;
  margin: 0;
  text-align: center;
}
</style>
